import Vue from 'vue'
import router from './router'
import store from './store'
import VueTabulator from 'vue-tabulator'
import VCalendar from 'v-calendar'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import './../node_modules/bulma/css/bulma.css'
import App from './App.vue'

Vue.config.productionTip = false

// Your web app's Firebase configuration
var config = {
  apiKey: 'AIzaSyDMAznaWJM5RGZH008waTHgU09p1sbWcTw',
  authDomain: 'critical-mention.firebaseapp.com',
  databaseURL: 'https://critical-mention.firebaseio.com',
  projectId: 'critical-mention',
  storageBucket: 'critical-mention.appspot.com',
  messagingSenderId: '290083127751',
  appId: '1:290083127751:web:4c63d9bf75d61b9f3619e2',
}

// Initialize Firebase
!firebase.apps.length ? firebase.initializeApp(config) : ''

Vue.use(require('vue-moment'))
Vue.use(VueTabulator)
Vue.use(VCalendar, {})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
